import dayjs from 'dayjs';
import { ENV_TYPE } from 'lib/constants/login';
import { ORIENTATION } from 'lib/constants/orientation';
import { oriNameSuffixMap, promotionNameSuffixMap } from 'lib/constants/operator';
import channelService from 'lib/services/channelService';
import { AWARD_TYPES } from 'lib/constants/award';
import { ATTA_REPORT } from 'lib/constants/atta';
import { urlConfig } from 'lib/config';
import { useGlobalStore } from 'lib/store';
import msdkUtil from './MSDK';
import session from './session';
import cookie from './cookie';
import { COOKIES_KEY } from './cookie/constants';
import UrlParams, { currentUrlParams } from './url';

/**
 * todo: refactor
 * 到月底剩余天数
 * @returns {Number} days: 到月底剩余天数
 */
export const getRemanningDays = function () {
  const date = new Date();
  const time = new Date(date.getTime());
  time.setMonth(date.getMonth() + 1);
  time.setDate(0);
  return time.getDate() > date.getDate() ? time.getDate() + 1 - date.getDate() : 0;
};

/**
 * 判断是否竖屏
 * @return {boolean}
 */
export const isVertical = function () {
  const mql = window.matchMedia('(orientation: portrait)');
  return !!mql.matches;
};

/**
 * 判断是否横屏
 * @return {boolean}
 */
export const isLandscape = function () {
  const mql = window.matchMedia('(orientation: landscape)');
  return !!mql.matches;
};

/**
 * 获取屏幕方向
 * @return {number}
 */
export const getOrientation = function () {
  return isLandscape() ? ORIENTATION.LANDSCAPE : isVertical() ? ORIENTATION.VERTICAL : ORIENTATION.UNKNOWN;
};

/**
 * 获取统计数据
 * @return {string}
 */
export const getStatisticParams = function () {
  return JSON.stringify({
    page_key: cookie.get('page_hash') || window?.VISION?.meta?.actKey,
    orientation: getOrientation(),
  });
};

/**
 * 是否订单时间超过固定权益调用最大月份
 */
export const isOrderTimeOverYear = (orderTime) => {
  const globalStore = useGlobalStore.getState();
  const nowDate = dayjs();
  const oldDate = dayjs(orderTime);
  const currentYear = nowDate.year();
  const currentMonth = nowDate.month() + 1;
  const orderYear = oldDate.year();
  const orderMonth = oldDate.month() + 1;
  const diff = (currentYear - orderYear) * 12 + (currentMonth - orderMonth);
  return diff + 1 > globalStore.maxMonth;
};

export const validMobile = mobile => /^1[0-9]{10}$/.test(mobile);
export const getGiftBtnType = (btnType) => {
  switch (btnType) {
    case AWARD_TYPES.MUST: {
      return 'gift';
    }
    case AWARD_TYPES.RIGHTS: {
      return 'benefit';
    }
    case AWARD_TYPES.LOTTERY: {
      return 'lot';
    }
    case AWARD_TYPES.LIMITED_RETAIN: {
      return 'limited_time_activity';
    }
    default: {
      return 'order';
    }
  }
};

export function getReceiveGiftReportKey(btnType) {
  switch (btnType) {
    case AWARD_TYPES.MUST: {
      return ATTA_REPORT.RECEIVE_PRIZE_RESULT.GIFT;
    }
    case AWARD_TYPES.RIGHTS: {
      return ATTA_REPORT.RECEIVE_PRIZE_RESULT.RIGHT;
    }
    case AWARD_TYPES.LOTTERY: {
      return ATTA_REPORT.RECEIVE_PRIZE_RESULT.LOTTERY;
    }
    case AWARD_TYPES.NORMAL: {
      return ATTA_REPORT.RECEIVE_PRIZE_RESULT.NORMAL;
    }
  }
}

export function getPackageName(operatorType, isPromotional, packageName) {
  const operatorName = isPromotional ? promotionNameSuffixMap.get(operatorType) : oriNameSuffixMap.get(operatorType);
  return `${channelService.channelName}${packageName || operatorName}`;
}

export function getPureText(richText) {
  let content = '';
  try {
    content = JSON.parse(richText).content;
  } catch (e) {
    return content;
  }
  const div = document.createElement('div');
  div.innerHTML = content;
  return div.innerText;
}

export function getLoginType() {
  if (msdkUtil.isMSDK) {
    return ENV_TYPE.MSDK;
  }

  const { token } = session.getSessionData();
  if (!token) {
    return ENV_TYPE.GUEST;
  }
  return ENV_TYPE.THIRD_LOGIN;
}

export const isiOS = () => {
  const e = navigator.userAgent;
  return /iphone|ipod|ipad|Mac OS X/i.test(e) || !!e.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

export function isQQBrowser() {
  const ua = navigator.userAgent;
  return ua.indexOf('MQQBrowser') > -1 || ua.match(/QQ\/([\d.]+)/); // 判断是否是 手Q内
}

// 当前环境处于iOS QQ内
export function iniOSQQ() {
  return isiOS() && isQQBrowser();
}

export function isQQApp() {
  const sUserAgent = navigator.userAgent;
  const REGEXP_IOS_QQ = new RegExp('(iPad|iPhone|iPod).*? (IPad)?QQ\\/([\\d\\.]+)');
  const REGEXP_ANDROID_QQ = new RegExp('\\bV1_AND_SQI?_([\\d\\.]+)(.*? QQ\\/([\\d\\.]+))?', 'ig');
  const isIphoneOSQQ = REGEXP_IOS_QQ.test(sUserAgent);
  const isAndroidQQ = REGEXP_ANDROID_QQ.test(sUserAgent);
  if (isIphoneOSQQ || isAndroidQQ) {
    return true;
  }
  return false;
}

export function isWXApp() {
  return /MicroMessenger/gi.test(navigator.userAgent);
}

export function getHostEnv() {
  // 普通环境
  if (isQQApp()) {
    return 2;
  }
  if (isWXApp()) {
    return 1;
  }

  if (msdkUtil.isMSDK) {
    return 3;
  }
  return 4;
}

export function getUserType() {
  if (msdkUtil.isMSDK) {
    return msdkUtil.MSDKChannel;
  }

  return cookie.get(COOKIES_KEY.LOGIN_TYPE) || '';
}

// 联通订购成功结果页生成
export function generatorOrderUrl(userOrderInfo) {
  const subStatTag = currentUrlParams.getCurrentParams('SubStatTag') || channelService.channelTag;
  const params = {
    ...currentUrlParams.getCurrentParams(),
    num: userOrderInfo.orderMobile,
    businessId: userOrderInfo.pId,
    app: channelService.gameCode,
    action: 1,
    Channel: channelService.channelCode,
    operator: userOrderInfo?.operatorType,
    supplierId: 201, // 写死联通supplierId，调用接口获取没必要
    // orderState: userOrderInfo.orderState, // 这里下单的时候 传过去没啥意义
    SubStatTag: subStatTag,
    orderSrc: 'activity',
  };

  return UrlParams.appendUrlParams(params, `${urlConfig.orderPageUrl}flow/result`);
}

export function htmlEncode(iStr) {
  let sStr = iStr;
  sStr = sStr?.replace(/&/g, '&amp;');
  sStr = sStr?.replace(/>/g, '&gt;');
  sStr = sStr?.replace(/</g, '&lt;');
  sStr = sStr?.replace(/"/g, '&quot;');
  sStr = sStr?.replace(/'/g, '&#39;');
  return sStr;
}

export function isAllowedDomainUrl(url) {
  return !!/^(https?:\/\/)?([\w\-.]+\.)?(flow|igame)\.qq\.com($|\/|\\)/i.test(url);
}

export function isValidURL(url) {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
}

// 获取当前本地日期（格式：YYYY-MM-DD）
const getCurrentDate = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(
    2,
    '0',
  )}`;
};

// 检查是否允许展示提示
export const shouldShowPrompt = (key) => {
  const lastDate = localStorage.getItem(key);
  const currentDate = getCurrentDate();
  // 若从未存储过，或上次存储的日期早于今天 → 允许展示
  return !lastDate || lastDate < currentDate;
};

// 标记提示已展示（点击关闭时调用）
export const markPromptShown = (key) => {
  const currentDate = getCurrentDate();
  localStorage.setItem(key, currentDate);
};
export function rem(px) {
  return `${(px / 200) * 1}rem`;
}
